<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <div class="button-group">
              <button
                @click="$helper.setFormBuilderMenu(true)"
                class="btn btn-success navbar-btn"
              >
                <i class="fa fa-wrench" aria-hidden="true"></i>
                {{ $helper.getWord("Open Menu") }}
              </button>
              <button
                @click="$helper.setFormBuilderMenu(false)"
                class="btn btn-danger navbar-btn"
              >
                <i class="fa fa-wrench" aria-hidden="true"></i>
                {{ $helper.getWord("Close Menu") }}
              </button>
            </div>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <div class="navbar-nav">
              <ul class="nav navbar-nav">
                <li>
                  <div
                    id="rdoGroupEditMode"
                    class="btn-group btn-group-toggle"
                    data-toggle="buttons"
                  >
                    <label class="btn btn-secondary canvasOption active">
                      <input
                        type="radio"
                        name="options"
                        id="edit"
                        value="edit"
                        checked=""
                      />
                      <i class="fa fa-edit"></i> {{ $helper.getWord("Edit") }}
                    </label>
                    <label class="btn btn-secondary canvasOption">
                      <input
                        type="radio"
                        name="options"
                        id="sourcepreview"
                        value="preview"
                      />
                      <i class="fa fa-eye"></i> {{ $helper.getWord("Preview") }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <div class="button-group">
              <!-- <button @click="clearForm" class="btn btn-secondary navbar-btn">Clear</button> -->
              <!-- <button @click="saveForm" class="btn btn-primary navbar-btn">Save</button> -->
              <button
                class="btn btn-secondary navbar-btn"
                data-target="#clearModal"
                role="button"
                data-toggle="modal"
              >
                <i class="fa icon-trash" style="color: #333"></i
                >{{ $helper.getWord("Clear") }}
              </button>

              <button
                type="button"
                class="btn btn-primary navbar-btn"
                rel="/build/downloadModal"
                role="button"
                data-toggle="modal"
                @click="saveForm"
              >
                <i class="fa icon-chevron-down"></i
                >{{ $helper.getWord("Save") }}
              </button>
            </div>
          </div>
        </template>
      </PageHeaderNoAction>
      <div id="download-layout">
        <div class="container-fluid">
          <!-- TEMP SAVE -->
        </div>
      </div>
    </section>
    <div
      class="fbcontainer ui-sortable"
      style="cursor: auto; width: auto; min-height: 500px; padding-top: 100px"
    >
      <!-- Drag and Drop -->
    </div>
    <div
      class="modal fade"
      id="clearModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="clearModal"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="clearModal">Form Clear</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">Are you sure want to clear the form?</div>
          </div>
          <div class="modal-footer">
            <button
              id="clear"
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="clearForm"
            >
              Confirm
            </button>
            <button type="button" class="btn" data-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from "@/api";
import config from "@/config";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Form Builder",
  access_code: "UBF_LIST01",
  hidden: true,
  icon: "far fa-copy fa-fw",
  components: {},
  order: 6,
  data() {
    return {};
  },
  created() {},
  destroyed() {
    helper.setFormBuilderMenu(false);
  },
  mounted() {
    console.log(this.$parent.$refs.sideBar);
    helper.setFormBuilderMenu(true);
    this.loadForm();
    this.togglePreview();
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    dataList() {
      return this.grid.selectRows || [];
    },
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    removeMenuClasses() {
      $("#menu-layoutit li button").removeClass("active");
    },
    togglePreview() {
      var vm = this;
      $("#rdoGroupEditMode").change(function (e) {
        if (e.target.value == "edit") {
          $("body").removeClass("devpreview sourcepreview");
          $("body").addClass("edit");
          vm.removeMenuClasses();
          $(this).addClass("active");
          $(".sidebar-nav .fbrow").draggable("enable");
          $(".sidebar-nav .box").draggable("enable");
          // } else if (e.target.value == 'developer') {
          //   $("body").removeClass("edit sourcepreview");
          //   $("body").addClass("devpreview");
          //   vm.removeMenuClasses();
          //   $(".sidebar-nav .fbrow").draggable('enable');
          //   $(this).addClass("active");
          //   $(".sidebar-nav .box").draggable('enable');
        } else if (e.target.value == "preview") {
          $("body").removeClass("edit devpreview");
          $("body").addClass("sourcepreview");
          vm.removeMenuClasses();
          $(this).addClass("active");
          $(".sidebar-nav .fbrow").draggable("disable");
          $(".sidebar-nav .box").draggable("disable");
        }
      });
    },
    compress(data, deflate) {
      if (data == null || data.length == 0 || typeof pako === "undefined") {
        return data;
      } else {
        var tmp = deflate
          ? pako.deflate(encodeURIComponent(data), { to: "string" })
          : pako.deflateRaw(encodeURIComponent(data), { to: "string" });

        return window.btoa ? btoa(tmp) : Base64.encode(tmp, true);
      }
    },
    decompress(data, inflate, checked) {
      var vm = this;
      if (data == null || data.length == 0 || typeof pako === "undefined") {
        return data;
      } else {
        var tmp = window.atob ? atob(data) : Base64.decode(data, true);

        var inflated = decodeURIComponent(
          inflate
            ? pako.inflate(tmp, { to: "string" })
            : pako.inflateRaw(tmp, { to: "string" })
        );

        return checked ? inflated : vm.zapGremlins(inflated);
      }
    },
    zapGremlins(text) {
      var checked = [];

      for (var i = 0; i < text.length; i++) {
        var code = text.charCodeAt(i);

        // Removes all control chars except TAB, LF and CR
        if (
          (code >= 32 || code == 9 || code == 10 || code == 13) &&
          code != 0xffff &&
          code != 0xfffe
        ) {
          checked.push(text.charAt(i));
        }
      }

      return checked.join("");
    },
    clearForm() {
      $(this.$el).find(".fbcontainer").empty();
    },
    cleanHtml(e) {
      $(e).parent().append($(e).children().html());
    },
    saveForm() {
      //Final save to the server
      var vm = this;
      var html = $(this.$el).find(".fbcontainer").html();

      let $result = $(".fbcontainer").find(".fbResult");
      $.each($result, function (key, value) {
        //for each components in the form builder, save from <formeditor/> to vuejs <fbtextbox/>, <fbselectbox/>...
        let $currentFormEditor = $(this)
          .parents(".fbrow")
          .first()
          .find("formeditor");
        let $textbox = $(this).children().first();
        let modelType = $currentFormEditor.attr("modelType");

        /* Save to <fbResult/> for Vue Component */
        if (modelType == "textInput") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr(
            "fbplaceholder",
            $currentFormEditor.attr("fbplaceholder")
          );
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fbminlength", $currentFormEditor.attr("fbminlength"));
          $textbox.attr("fbmaxlength", $currentFormEditor.attr("fbmaxlength"));
          $textbox.attr("fbtype", $currentFormEditor.attr("fbtype"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr("fb:value", null);
          $textbox.attr("fbinputmask", $currentFormEditor.attr("fbinputmask"));
          $textbox.attr("fbtextcase", $currentFormEditor.attr("fbtextcase"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          if ($currentFormEditor.attr("fbtype") == "postcode") {
            let options = $currentFormEditor.attr("fbtypedetail");
            if (options) {
              $textbox.attr("fb:value", `postcode(${options})`);
            }
          }

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "numberInput") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fbmaxlength", $currentFormEditor.attr("fbmaxlength"));
          $textbox.attr("fbtype", $currentFormEditor.attr("fbtype"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr(
            "fbdecimalplaces",
            $currentFormEditor.attr("fbdecimalplaces")
          );
          $textbox.attr("fb:value", null);
          $textbox.attr("fbinputmask", $currentFormEditor.attr("fbinputmask"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          let options = $currentFormEditor.attr("fbtypedetail");

          if ($currentFormEditor.attr("fbtype") == "amount") {
            if (options) {
              $textbox.attr("fb:value", `sum(${options})`);
            }
          } else if ($currentFormEditor.attr("fbtype") == "count") {
            if (options) {
              $textbox.attr("fb:value", `count(${options})`);
            }
          } else if ($currentFormEditor.attr("fbtype") == "multiplication") {
            if (options) {
              $textbox.attr("fb:value", `multiplication(${options})`);
            }
          } else if ($currentFormEditor.attr("fbtype") == "percentage") {
            if (options) {
              $textbox.attr("fb:value", `percentage(${options})`);
            }
          } else if ($currentFormEditor.attr("fbtype") == "gst") {
            if (options) {
              $textbox.attr("fb:value", `gst(${options})`);
            }
          } else if ($currentFormEditor.attr("fbtype") == "dateDifference") {
            if (options) {
              $textbox.attr("fb:value", `dateDifference(${options})`);
            }
          } else if ($currentFormEditor.attr("fbtype") == "difference") {
            if (options) {
              $textbox.attr("fb:value", `difference(${options})`);
            }
          }
          $textbox.attr("fbtypedetail", options);

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "textArea") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr(
            "fbplaceholder",
            $currentFormEditor.attr("fbplaceholder")
          );
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fbrows", $currentFormEditor.attr("fbrows"));
          $textbox.attr("fbmaxlength", $currentFormEditor.attr("fbmaxlength"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr("fbinputmask", $currentFormEditor.attr("fbinputmask"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "dateInput" || modelType == "dateTimeInput") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr(
            "fbplaceholder",
            $currentFormEditor.attr("fbplaceholder")
          );
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr("fbtype", $currentFormEditor.attr("fbtype"));
          $textbox.attr("fbinputmask", $currentFormEditor.attr("fbinputmask"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          if ($currentFormEditor.attr("fbtype") == "startFromDate") {
            let options = $currentFormEditor.attr("fbtypedetail");
            if (options) {
              $textbox.attr("fb:value", `startFromDate(${options})`);
            }
            $textbox.attr("fbtypedetail", options);
          }

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "selectBox") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );
          $textbox.attr(
            "fbplaceholder",
            $currentFormEditor.attr("fbplaceholder")
          );
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fbmaxlength", $currentFormEditor.attr("fbmaxlength"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr(
            "fb:approvalEdit",
            $currentFormEditor.attr("fb:approvalEdit")
          );
          $textbox.attr("fbtype", $currentFormEditor.attr("fbtype"));
          $textbox.attr("fbcountry", $currentFormEditor.attr("fbcountry"));

          if ($currentFormEditor.attr("fbtype") == "postcode") {
            let options = $currentFormEditor.attr("fbtypedetail");
            if (options) {
              $textbox.attr("fb:value", `postcode(${options})`);
            }
          } else {
            $textbox.empty();
            let options = "[";
            for (let i = 1; i <= $currentFormEditor.children().length; i++) {
              let value = $currentFormEditor
                .find(`option:nth-child(${i})`)
                .attr("fbselectvalue");
              let label = $currentFormEditor
                .find(`option:nth-child(${i})`)
                .attr("fbselectlabel");
              options += `{Key: '${label}', Value: '${value}'}, `;
              if (i == $currentFormEditor.children().length) {
                options = options.slice(0, -2);
              }
            }

            options = options + "]";
            console.log(options);
            $textbox.attr("fb:fboptions", options); //:options
          }

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "preparerselectbox") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );
          $textbox.attr(
            "fb:updatepreparerid",
            $currentFormEditor.attr("fb:updatepreparerid")
          );
          $textbox.attr(
            "fb:fboptions",
            $currentFormEditor.attr("fb:fboptions")
          );
          $textbox.attr("fb:ajaxurl", $currentFormEditor.attr("fb:ajaxurl"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr(
            "fb:approvalEdit",
            $currentFormEditor.attr("fb:approvalEdit")
          );
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr("fbv-model", $currentFormEditor.attr("fbv-model"));
          $textbox.attr(
            "fb:createuser",
            $currentFormEditor.attr("fb:createuser")
          );
        } else if (modelType == "radioBox" || modelType == "checkBoxes") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fbmaxlength", $currentFormEditor.attr("fbmaxlength"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          $textbox.empty();
          let options = "[";
          for (let i = 1; i <= $currentFormEditor.children().length; i++) {
            let value = $currentFormEditor
              .find(`option:nth-child(${i})`)
              .attr("fbselectvalue");
            let label = $currentFormEditor
              .find(`option:nth-child(${i})`)
              .attr("fbselectlabel");
            options += `{Key: '${label}', Value: '${value}'}, `;
            if (i == $currentFormEditor.children().length) {
              options = options.slice(0, -2);
            }
          }
          options += "]";
          $textbox.attr("fb:fboptions", options); //:options

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            console.log(detailTable);
            console.log(model.split(".").pop());
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "checkBox") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          let options = "[";
          options += `{Key: '${true}', Value:'${$textbox.attr("fblabel")}'}`;
          options += "]";
          $textbox.attr("fboptions", options);

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            console.log(detailTable);
            console.log(model.split(".").pop());
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "fileUpload") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fb:isMobile", $currentFormEditor.attr("fb:isMobile"));
          $textbox.attr(
            "fb:deleteFileList",
            $currentFormEditor.attr("fb:deleteFileList")
          );

          $textbox.attr(
            "fb:fileResponse",
            $currentFormEditor.attr("fb:fileResponse")
          );
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
            $textbox.attr("fb:attachmentList", "d.attachmentList");
          } else {
            $textbox.attr("fbv-model", model);
            //$textbox.attr(':attachmentList', $currentFormEditor.attr(':attachmentList'));
            $textbox.attr(
              "fb:attachmentList",
              "formData." +
                modelBuilder.mainTable.property.table_name +
                ".attachmentList"
            );
          }
        } else if (modelType == "ocrbutton") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fb:isMobile", $currentFormEditor.attr("fb:isMobile"));
          $textbox.attr(
            "fb:deleteFileList",
            $currentFormEditor.attr("fb:deleteFileList")
          );

          $textbox.attr(
            "fb:fileResponse",
            $currentFormEditor.attr("fb:fileResponse")
          );
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr(
            "fbtypedetail",
            $currentFormEditor.attr("fbtypedetail")
          );
          $textbox.attr("fbv-on:ocrfunction", "ocrfunction");

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
            $textbox.attr("fb:attachmentList", "d.attachmentList");
          } else {
            $textbox.attr("fbv-model", model);
            //$textbox.attr(':attachmentList', $currentFormEditor.attr(':attachmentList'));
            $textbox.attr(
              "fb:attachmentList",
              "formData." +
                modelBuilder.mainTable.property.table_name +
                ".attachmentList"
            );
          }
        } else if (modelType == "dayOrHourInput") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));
          $textbox.attr(
            "fbplaceholder",
            $currentFormEditor.attr("fbplaceholder")
          );
          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );
          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fbmaxlength", $currentFormEditor.attr("fbmaxlength"));
          $textbox.attr("fbtype", $currentFormEditor.attr("fbtype"));
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr("fb:value", null);
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          if ($currentFormEditor.attr("fbtype") == "postcode") {
            let options = $currentFormEditor.attr("fbtypedetail");
            if (options) {
              $textbox.attr("fb:value", `postcode(${options})`);
            }
          }

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "signature") {
          $textbox.attr("fblabel", $currentFormEditor.attr("fblabel"));
          $textbox.attr("fbhidelabel", $currentFormEditor.attr("fbhidelabel"));
          $textbox.attr("fbreadonly", $currentFormEditor.attr("fbreadonly"));
          $textbox.attr("fbrequired", $currentFormEditor.attr("fbrequired"));
          $textbox.attr("fbinvisible", $currentFormEditor.attr("fbinvisible"));

          $textbox.attr("fbhelptext", $currentFormEditor.attr("fbhelptext"));
          $textbox.attr(
            "fblabelposition",
            $currentFormEditor.attr("fblabelposition")
          );

          $textbox.attr(
            "mb_form_table_id",
            $currentFormEditor.attr("mb_form_table_id")
          );
          $textbox.attr(
            "mb_form_table_type",
            $currentFormEditor.attr("mb_form_table_type")
          );
          $textbox.attr(
            "mb_form_column_id",
            $currentFormEditor.attr("mb_form_column_id")
          );
          $textbox.attr("column_name", $currentFormEditor.attr("column_name"));
          $textbox.attr("fbvalue", $currentFormEditor.attr("value"));
          $textbox.attr("fbmaxlength", $currentFormEditor.attr("fbmaxlength"));

          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
          $textbox.attr("fb:value", null);
          $textbox.attr(
            "fbsubmitcanchange",
            $currentFormEditor.attr("fbsubmitcanchange")
          );
          $textbox.attr(
            "fbsupportmultiplelanguages",
            $currentFormEditor.attr("fbsupportmultiplelanguages")
          );

          let model = $currentFormEditor.attr("fbv-model");
          let detailTable = $currentFormEditor.parents(".fbDetailTable").first()
            .length;
          if (detailTable > 0) {
            //Component inside detail table
            $textbox.attr("fbv-model", "d." + model.split(".").pop());
          } else {
            $textbox.attr("fbv-model", model);
          }
        } else if (modelType == "recaptcha") {
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
        } else if (modelType == "ocr") {
          $textbox.attr("fb:isEdit", $currentFormEditor.attr("fb:isEdit"));
        }
      });

      $("#download-layout").children().html($(".fbcontainer").html());

      var e = "";
      var t = $("#download-layout").children();
      t.find(".preview, .configuration, .drag, .remove").remove();
      t.find(".fbrow").addClass("removeClean");
      t.find(".box-element").addClass("removeClean");
      t.find(".fbrow .fbrow .fbrow .fbrow .fbrow .removeClean").each(
        function () {
          vm.cleanHtml(this);
        }
      );
      t.find(".fbrow .fbrow .fbrow .fbrow .removeClean").each(function () {
        vm.cleanHtml(this);
      });
      t.find(".fbrow .fbrow .fbrow .removeClean").each(function () {
        vm.cleanHtml(this);
      });
      t.find(".fbrow .fbrow .removeClean").each(function () {
        vm.cleanHtml(this);
      });
      t.find(".fbrow .removeClean").each(function () {
        vm.cleanHtml(this);
      });
      t.find(".removeClean").each(function () {
        vm.cleanHtml(this);
      });
      t.find(".removeClean").remove();
      $("#download-layout .column").removeClass("ui-sortable");
      $("#download-layout .row-fluid")
        .removeClass("clearfix")
        .children()
        .removeClass("column");
      if ($("#download-layout .container").length > 0) {
        changeStructure("row-fluid", "row");
      }

      //$("#download-layout").html()
      var formatSrc = $.htmlClean(t.html(), {
        format: true,
        allowedAttributes: [
          ["id"],
          ["class"],
          ["style"],
          ["data-toggle"],
          ["data-target"],
          ["data-parent"],
          ["role"],
          ["data-dismiss"],
          ["aria-labelledby"],
          ["aria-hidden"],
          ["data-slide-to"],
          ["data-slide"],
          ["fbv-if"],
          ["fbv-model"],
          ["fbv-for"],
          ["fbv-show"],
          ["fbv-bind"],
          ["fblabel"], //get from <formeditor/> attribute
          ["fbhidelabel"],
          ["fbplaceholder"],
          ["fbhelptext"],
          ["fbtooltip"],
          ["fblabelposition"],
          ["fbinputmask"],
          ["fbreadonly"],
          ["fbsubmitcanchange"],
          ["fbsupportmultiplelanguages"],
          ["fbvalue"],
          ["fbtextcase"],
          ["fbminlength"],
          ["fbmaxlength"],
          ["fbselectlabel"],
          ["fbselectvalue"],
          ["fbrequired"],
          ["fbinvisible"],
          ["fbtype"],
          ["fbrows"],
          ["fbtypedetail"],
          ["fbcountry"],
          ["fbdecimalplaces"],
          ["fbv-on:click"],
          ["fbv-on:input"],
          ["fbv-on:ocrfunction"],
          ["fb:key"],
          ["mb_form_column_id"],
          ["column_name"],
          ["fbtablename"],
          ["mb_form_table_id"],
          ["mb_form_table_type"],
          ["fb:ismobile"],
          ["fb:isedit"],
          ["fb:approvaledit"],
          ["fb:fileresponse"],
          ["fb:deletefilelist"],
          ["fb:attachmentlist"],
          ["fb:value"],
          ["fb:index"],
          ["fb:ocr"],
          ["fb:fboptions"],
          ["fb:ajaxurl"],
          ["fb:updatepreparerid"],
          ["fb:createuser"],
        ],
        replace: [
          //NOT WORKING
          // ['&quot;', '"'],
          // ["fbv\-on:click", "v\-on:click"],
          // ["fbv\-on:input", "v\-on:input"],
          // ["fb:key", ":key"],
          // ["fb:ismobile", ":ismobile"],
          // ['fb:isedit', ':isedit'],
          // ['fb:fileresponse', ':fileresponse'],
          // ['fb:deletefilelist',':deletefilelist'],
          // ['fb:attachmentlist',':attachmentlist'],
          // ['fb:value',':value'],
          // ['fb:options',':options'],
          // ['fbv-if', 'v-if'],
          // ['fbv-for', 'v-for']
          // ["fbv-model", "v-model"],
          // ["fbv-show", "v-show"],
          // ["fbv-bind", "v-bind"],
        ],
      });

      //var $temp = $(formatSrc);
      formatSrc = '<div class="container-fluid">' + formatSrc + "</div>";
      formatSrc = formatSrc.replace(/&quot;/g, `"`);
      formatSrc = formatSrc.replace(/fbv-on:click/g, "v-on:click");
      formatSrc = formatSrc.replace(/fbv-on:input/g, "fbv-on:input");
      formatSrc = formatSrc.replace(/fbv-on:ocrfunction/g, "v-on:ocrfunction");

      formatSrc = formatSrc.replace(/fb:key/g, ":key");
      formatSrc = formatSrc.replace(/fb:ismobile/g, ":ismobile");
      formatSrc = formatSrc.replace(/fb:isedit/g, ":isedit");
      formatSrc = formatSrc.replace(/fb:approvaledit/g, ":approvaledit");
      formatSrc = formatSrc.replace(/fb:fileresponse/g, ":fileresponse");
      formatSrc = formatSrc.replace(/fb:deletefilelist/g, ":deletefilelist");
      formatSrc = formatSrc.replace(/fb:attachmentlist/g, ":attachmentlist");
      formatSrc = formatSrc.replace(/fb:index/g, ":index");
      formatSrc = formatSrc.replace(/fb:ocr/g, ":ocr");
      formatSrc = formatSrc.replace(/fb:value/g, ":value");
      formatSrc = formatSrc.replace(/fb:fboptions/g, ":fboptions");
      formatSrc = formatSrc.replace(/fb:ajaxurl/g, ":ajaxurl");
      formatSrc = formatSrc.replace(/fbv-if/g, "v-if");
      formatSrc = formatSrc.replace(/fbv-for/g, "v-for");
      formatSrc = formatSrc.replace(/fbv-model/g, "v-model");
      formatSrc = formatSrc.replace(/fbv-show/g, "v-show");
      formatSrc = formatSrc.replace(/fbv-bind/g, "v-bind");
      formatSrc = formatSrc.replace(
        /fb:updatepreparerid/g,
        "@updatePreparerID"
      );
      formatSrc = formatSrc.replace(/fb:createuser/g, ":createuser");

      var webpage = $(".fbcontainer")
        .html()
        .replace(/&quot;/g, `"`);

      var webpageVue = formatSrc;

      var cpath = window.location.href;
      cpath = cpath.substring(0, cpath.lastIndexOf("/"));
      var data = {};
      var key = CryptoJS.enc.Utf8.parse("8080808080808080");
      var iv = CryptoJS.enc.Utf8.parse("8080808080808080");
      data.ApiKey = config.apiKey;
      data.ApiSystemName = config.apiSystemName;
      data.Parameters = {};
      data.Parameters.id = this.$route.query.ID;
    
      var htmlCode = CryptoJS.AES.encrypt(webpage, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();

      data.Parameters.htmlCode = htmlCode;
      var useCode = CryptoJS.AES.encrypt(webpageVue, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();

      data.Parameters.useCode = useCode;

      var responseType = "json";
      $.blockUI({
        message: '<h1><img src="images/ajax-loader.gif" /> Loading...</h1>',
      });
      axios({
        method: "POST",
        url: config.serverURI + "/api/userBuildForm/saveFormBuilder",
        data: data,
        crossDomain: true,
        responseType: responseType,
        headers: {
          "Content-type": "application/json; charset=utf-8",
        },
      })
        .then((response) => {
          var r = response.data;

          if (r.code == 200) {
            console.log(r);
            $.unblockUI();
          } else if (r.code !== 200 && config.logApplicationError) {
            console.error(r.message);
            $.unblockUI();
            return;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 440) {
          } else {
            if (
              error.response &&
              error.response.data &&
              error.response.data.Message
            ) {
              console.error(error.response.data.Message);
            } else if (
              error.response &&
              responseType === "blob" &&
              error.response.statusText
            ) {
              console.error(error.response.statusText);
            } else if (error.message) {
              console.error(error.message);
            }
          }
          $.unblockUI();
        });
    },
    loadForm() {
      var vm = this;
      helper.loading();
      api.request(
        this,
        "post",
        `/userBuildForm/getFormEditDetail`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            ID: vm.$route.query.ID,
          },
        },
        function (r) {
          var htmlcode="";
          if(r.data.htmlCode!=null){
            var key = CryptoJS.enc.Utf8.parse("8080808080808080");
                var iv = CryptoJS.enc.Utf8.parse("8080808080808080");
                htmlcode = CryptoJS.AES.decrypt(r.data.htmlCode, key, {
                  keySize: 128 / 8,
                  iv: iv,
                  mode: CryptoJS.mode.CBC,
                  padding: CryptoJS.pad.Pkcs7
                }).toString(CryptoJS.enc.Utf8);
      }
          $(".fbcontainer").empty();
          $(".fbcontainer").append(htmlcode);
          helper.done();
        },
        function (r) {
          helper.done();
        }
      );
    },
  },
};
</script>
<style >
.fbinput {
  padding-bottom: 8px;
}
</style>
<style scoped>
.section-body {
  padding-top: 100px;
}
</style>
